import React from 'react';
import { IContent } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './Title.scss';

interface ITitleProps {
  context?: IContent;
  titles: string[];
  color: string;
}

const Title = ({ titles, color }: ITitleProps) => {
  return (
    <div className="title-container">
      <h2 className="section-title">
        {titles.map((title: string, index: number) => {
          return (
            <span
              className="title-headline"
              key={index}
              style={{ color: index % 2 !== 0 ? color : '#FFFFFF' }}
            >{`${title} `}</span>
          );
        })}
      </h2>
    </div>
  );
};
export default withContent(Title);
